const USD_LOCALE = 'en-US';
const USD_FRACTION_DIGITS = 2;

/**
 * Format a USD amount — always two decimals, always the same shape.
 *
 * The locale is forced to `en-US` rather than left to the viewer: an undefined locale renders USD as
 * `999,05 $` under, for example, `ru-RU`, and every billed figure across the Clarity billing and
 * usage surfaces has to read identically.
 *
 * Ported from Clarity `apps/web/src/shared/utils/formatUsd.ts`. No workspace equivalent exists —
 * the one currency formatter in this repo is private to `subscription-form.service.ts`.
 */
export function formatUsd(value: number): string {
	return new Intl.NumberFormat(USD_LOCALE, {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: USD_FRACTION_DIGITS,
		maximumFractionDigits: USD_FRACTION_DIGITS,
	}).format(value);
}
